import {
  FormConfig,
  IBasicSearchPaginationProps,
} from 'src/app/shared/models/dynamic.model';
import { MiscellaneousComponent } from './bag-information/miscellaneous/miscellaneous.component';
import {
  ComponentMapping,
  IBagAttachmentData,
  IBagInformationData,
  IBagLinkedShipmentData,
  IBagMiscellaneousData,
  IBagNotesData,
  ShipmentGridColumnData,
  TableColumns,
  Widget,
  bagColumnData,
  BagGatewayGridRow,
} from '../../model/bag.model';
import {
  BulkDeleteItemNames,
  GridColumnsStorageNames,
  gridMessages,
  MessageTemplates,
  searchDataParam,
  validationErrorMessages,
} from 'src/app/shared/utility/constants';
import {
  ACCORDION_TAB_SHORTCUTS_MISCELLANEOUS,
  ACCORDION_TAB_SHORTCUTS_NOTES_TO_DETAILS,
} from 'src/app/shared/config/information-accordion-tab-shortcuts.config';
import { TimelineDataItem } from '../../model/manifest.model';
import { TableColumnsProp } from 'src/app/shared/models/tables.model';
import { DataTableConfig } from 'src/app/shared/components/data-table';

/* Default Widget Configuration */
export const widgets: Widget[] = [
  {
    id: 1,
    title: 'Total Weight',
    value: '--',
    extraClasses: 'pt-6',
    controlName: 'totalWeight',
    iconName: 'weight',
    name: 'totalWeight',
  },
  {
    id: 2,
    extraClasses: 'pt-6',
    iconName: 'hawbNumbers',
    name: 'totalNoOfHawbs',
    controlName: 'noOfShipment',
    title: 'Number of Shipments',
    value: '--',
  },
];

/* Bag Information Form Fields Configuration */
export const bagInfoFormFieldsConfig: FormConfig = {
  fields: [
    {
      id: 'bagNumber',
      type: 'input',
      label: 'Bag',
      required: true,
      requiredError: 'Bag Ext is required',
      minValue: 3,
      maxValue: 126,
      minError: 'Invalid Bag entered',
      noInitialWhiteSpace: true,
      allowAlphaNumericWithUnderscoreOnlySpecialCharacters: true,
    },
    {
      id: 'origin',
      type: 'input',
      label: 'Origin',
      required: true,
      requiredError: 'Origin is required',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'destination',
      type: 'input',
      label: 'Destination',
      required: true,
      requiredError: 'Destination is required',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'manifestNumber',
      type: 'input',
      label: 'Manifest',
    },
    {
      id: 'manifestId',
      type: 'input',
      label: 'Manifest Id',
    },
    {
      id: 'originId',
      type: 'input',
      label: 'Origin Id',
    },
    {
      id: 'destinationId',
      type: 'input',
      label: 'Destination Id',
    },
    { id: 'bagId', type: 'input', label: 'Bag Id', isDisableField: true },
    {
      id: 'description',
      type: 'input',
      label: 'Description',
      maxValue: 1000,
      noInitialWhiteSpace: true,
    },
  ],
};

/* Component Mappings Configuration */
export const componentMappings: ComponentMapping[] = [
  { title: 'Miscellaneous', componentType: MiscellaneousComponent },
  { title: 'Statuscodes', componentType: '' },
  { title: 'Notes', componentType: '' },
  { title: 'Events', componentType: '' },
  { title: 'Attachments', componentType: '' },
  { title: 'Details', componentType: '' },
];

export const INFORMATION_ACCORDION_TAB_SHORTCUTS: Readonly<
  Record<string, string>
> = {
  ...ACCORDION_TAB_SHORTCUTS_NOTES_TO_DETAILS,
  ...ACCORDION_TAB_SHORTCUTS_MISCELLANEOUS,
};

/* Miscellaneous Form Fields Configuration */
export const miscellaneousFormfieldsConfig: FormConfig = {
  fields: [
    {
      id: 'tareWeight',
      type: 'input',
      label: 'Tare Weight(lb)',
    },
  ],
};

/* Piece Table Fields Configuration */
export const pieceTablefieldsConfig: FormConfig = {
  fields: [
    {
      id: 'pieceExt',
      type: 'input',
      label: 'Piece Ext',
    },
  ],
};

/* Piece Grid Input Row Data Configuration */
export const shipmentGridInputRowData: ShipmentGridColumnData[] = [
  {
    id: '',
    weight: '',
    dimensions: '',
    hawbExt: '',
    isInputRow: true,
    shipper: '',
    consignee: '',
  },
];

/* Search Form Fields Configuration */
export const searchFormfieldsConfig: FormConfig = {
  fields: [
    {
      id: 'bagId',
      type: 'input',
      label: 'Bag',
      minValue: 1,
      maxValue: 11,
      allowAlphaNumeric: true,
    },
    {
      id: 'origin',
      type: 'input',
      label: 'Origin',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'destination',
      type: 'input',
      label: 'Destination',
      minValue: 1,
      maxValue: 126,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
    },
    {
      id: 'package',
      type: 'input',
      label: 'Package',
      allowAlphabet: true,
      minValue: 1,
      maxValue: 50,
    },
    {
      id: 'manifest',
      type: 'input',
      label: 'Manifest',
      allowNumeric: true,
      maxValue: 14,
    },
    {
      id: 'flightNumber',
      type: 'input',
      label: 'Flight Number',
      minValue: 1,
      maxValue: 6,
    },
    { id: 'originData', type: 'input', label: 'Origin Data' },
    { id: 'packaging', type: 'input', label: 'Packaging Data' },
    { id: 'airline', type: 'input', label: 'Airline' },
  ],
};

/* Grid Summary Columns Configuration */
export const gridSummaryColumns: TableColumns[] = [
  ...new Set([
    {
      key: 'bagExt',
      label: 'Bag',
      value: 'bagExt',
      isSelected: true,
      defaultView: true,
      defaultPrintWidth: 175,
      isEditable: false,
    },
    {
      key: 'noofShipments',
      label: 'Shipment',
      isSelected: true,
      defaultView: true,
      value: 'noofShipments',
      defaultPrintWidth: 100,
    },
    {
      key: 'weight',
      label: 'Weight (lb)',
      value: 'weight',
      isSelected: true,
      defaultView: true,
      defaultPrintWidth: 110,
    },
    {
      key: 'manifestNo',
      isSelected: true,
      label: 'Manifest Number',
      value: 'manifestNo',
      defaultView: true,
      defaultPrintWidth: 100,
    },
  ]),
];

/* Piece Table Grid Columns Configuration */
export const shipmentTableGridColumns = [
  {
    key: 'hawbExt',
    label: 'Shipment',
    isSelected: true,
    defaultPrintWidth: 175,
  },
  {
    key: 'weight',
    label: 'Weight (lb)',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'dimensions',
    label: 'Dimension L-W-H (inch)',
    isSelected: true,
    defaultPrintWidth: 190,
  },
  {
    key: 'shipper',
    label: 'Shipper',
    isSelected: true,
    defaultPrintWidth: 190,
  },
  {
    key: 'consignee',
    label: 'Consignee',
    isSelected: true,
    defaultPrintWidth: 190,
  },
];

/* Bag Information - Default Values Configuration */
export const defaultBagNotesData = (): IBagNotesData => ({
  ibc: [],
  customer: [],
});

export const defaultBagAttachmentsData = (): IBagAttachmentData[] => [
  {
    id: '',
    type: '',
    fileName: '',
    signedUrl: '',
    action: '',
    attachmentTypeValuId: '',
  },
];

export const defaultBagMiscellaneousData = (): IBagMiscellaneousData => ({
  tareWeight: '',
});
export const defaultBagShipmentData = (): IBagLinkedShipmentData[] => [
  { id: '', action: '' },
];
export const defaultBagInformationData = (): IBagInformationData => ({
  bagId: 0,
  bagNumber: '',
  hawbId: 0,
  origin: '',
  destination: '',
  packagingType: 0,
  manifestNumber: '',
  flightNumber: '',
  description: '',
  notes: defaultBagNotesData(),
  attachmentList: defaultBagAttachmentsData(),
  miscellaneous: defaultBagMiscellaneousData(),
  shipmentList: defaultBagShipmentData(),
  eventsList: [],
});

export const bagExcelColumn: string[] = [
  'bagExt',
  'noofShipments',
  'weight',
  'manifestNo',
];
export const defaultGridDisplayColumns: string[] = [
  'select',
  ...bagExcelColumn,
  'action',
];

export const BagExcelHeaders: string[] = [
  'Bag',
  'Shipment',
  'Weight (lb)',
  'Manifest Number',
];

export const defautBagPagination = {
  fromIndex: 0,
  toIndex: 10,
  sortingOrder: searchDataParam.desc,
  sortingField: searchDataParam.bagExt,
};

export const desiredBagPackage = ['B', 'C', 'G', 'O', 'A'];

export const BagSearchConfig: IBasicSearchPaginationProps = {
  fromIndex: 0,
  toIndex: 10,
  sortingOrder: 'desc',
  sortingField: searchDataParam.bagId,
};

export const BagInfoSectionHeaders: string[] = [
  'Widgets',
  'Bag Information',
  'Miscellaneous',
  'Notes',
  'Events',
  'Attachments',
  'Details',
  'Shipment(s) linked',
];
export const BagInfoSectionHeaderKeys: string[] = [
  'widgets',
  'bagInfo',
  'bagMiscellaneous',
  'notes',
  'events',
  'attachments',
  'details',
  'bagPieces',
];
export const BagInfoHeaders = [
  {
    key: 'bagNumber',
    label: 'Bag',
    isSelected: true,
    defaultPrintWidth: 175,
  },
  {
    key: 'origin',
    label: 'Origin',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'destination',
    label: 'Destination',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'manifestNumber',
    label: 'Manifest Number',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'description',
    label: 'Description',
    isSelected: true,
    defaultPrintWidth: 150,
  },
];

export const BagDetailsHeaders = [
  {
    key: 'bagId',
    label: 'Bag ID',
    isSelected: true,
    defaultPrintWidth: 150,
  },
];

export const BagMiscellaneousHeaders = [
  {
    key: 'tareWeight',
    label: 'Tare Weight',
    isSelected: true,
    defaultPrintWidth: 170,
  },
];

export const bagWidgetTableGridColumns = [
  {
    key: 'totalWeight',
    label: 'Total Weight',
    isSelected: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'totalNoOfHawbs',
    label: 'Number of Shipments',
    isSelected: true,
    defaultPrintWidth: 175,
  },
];

export const shipmentMultipleTableGridColumns = [
  {
    key: 'hawbExt',
    label: 'Shipment',
    isSelected: true,
    defaultPrintWidth: 175,
  },
  {
    key: 'accountDetails',
    label: 'Account',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'consignee',
    label: 'Consignee Name',
    isSelected: true,
    defaultPrintWidth: 190,
  },
  {
    key: 'origin',
    label: 'Origin',
    isSelected: true,
    defaultPrintWidth: 190,
  },
  {
    key: 'destination',
    label: 'Destination',
    isSelected: true,
    defaultPrintWidth: 190,
  },
  {
    key: 'weight',
    label: 'Weight (lb)',
    isSelected: true,
    defaultPrintWidth: 120,
  },
  {
    key: 'dimension',
    label: 'Dimension(L-W-H)',
    isSelected: true,
    defaultPrintWidth: 120,
  },
];

export const bagTimelineData: TimelineDataItem[] = [
  {
    date: '3/21/2024',
    time: '11:11:11',
    event: 'Bag updated',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Notes updated',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Notes added',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Bag created',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Bag updated',
  },
  {
    date: '12/12/2008',
    time: '10:10:10',
    event: 'Bag attachment added',
  },
];

export const gatewayBagByIncomingContainer: FormConfig = {
  fields: [
    {
      id: 'scanIncomingBag',
      label: 'Scan Incoming Bag',
      type: 'input',
      required: true,
      requiredError: 'Scan Incoming Bag is required',
      minValue: 3,
      maxValue: 126,
      minError:
        'Bag should be between 3 and 126 characters long and can have alphabets, numbers and special characters',
    },
    {
      id: 'outgoingBag',
      minValue: 3,
      type: 'input',
      maxValue: 126,
      label: 'Outgoing Bag',
      required: true,
      requiredError: 'Outgoing Bag is required',
      minError:
        'Bag should be between 3 and 126 characters long and can have alphabets, numbers and special characters',
    },
    {
      type: 'input',
      allowAlphaNumericWithDotUnderscoreDashSpecialCharacters: true,
      minValue: 3,
      label: 'Outgoing Manifest',
      required: true,
      requiredError: 'Outgoing Manifest is required',
      id: 'outgoingManifest',
      maxValue: 126,
      minError:
        'Manifest Number should be between 3 and 126 characters long and can have alphabets and special characters(”_” ,”.” and “-“)',
    },
  ],
};

export const bagGatewayTableColumnConfig: TableColumnsProp[] = [
  {
    key: 'noOfShipments',
    label: 'Number of Shipments',
    isSelected: true,
  },
  {
    key: 'shipper',
    label: 'Shipper',
    isSelected: true,
  },
  {
    key: 'incomingManifest',
    label: 'Incoming Manifest',
    isSelected: true,
  },
];

export const bagGatewayDataTableConfig: DataTableConfig<BagGatewayGridRow> = {
  rowIdField: 'id',
  entityName: 'Shipments',
  storageKey: GridColumnsStorageNames.bagGateway,
  columns: bagGatewayTableColumnConfig.map(column => ({
    key: column.key,
    label: column.label,
    isSelected: column.isSelected ?? true,
    defaultView: column.defaultView ?? true,
    sortable: true,
  })),
  features: {
    selection: false,
    pagination: false,
    sorting: true,
    columnReorder: false,
    selectAllAcrossPages: false,
    columnCustomization: false,
  },
  messages: {
    noSearch: gridMessages.noBagGateway,
    noMatch: gridMessages.noBagGateway,
    allPageSelected: (entity, count) => `All ${count} ${entity} selected.`,
    selectAll: (entity, total) => `Select all ${total} ${entity}`,
  },
};

export const bagDataTableConfig: DataTableConfig<bagColumnData> = {
  rowIdField: 'bagId',
  entityName: BulkDeleteItemNames.Bags,
  storageKey: GridColumnsStorageNames.bag,
  columns: [
    {
      key: 'bagExt',
      label: 'Bag',
      isSelected: true,
      defaultView: true,
      sortable: true,
      isHyperlink: true,
      defaultPrintWidth: 175,
    },
    {
      key: 'noofShipments',
      label: 'Shipment',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 100,
    },
    {
      key: 'weight',
      label: 'Weight (lb)',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 110,
    },
    {
      key: 'manifestNo',
      label: 'Manifest Number',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 100,
    },
  ],
  features: {
    selection: true,
    pagination: true,
    sorting: true,
    columnReorder: true,
    selectAllAcrossPages: true,
    columnCustomization: true,
  },
  messages: {
    noSearch: validationErrorMessages.bagBeforeSearch,
    noMatch: validationErrorMessages.bagAfterSearch,
    allPageSelected: MessageTemplates.AllItemsSelected,
    selectAll: MessageTemplates.SelectAllItems,
  },
  defaultPagination: {
    pageSize: BagSearchConfig.toIndex - BagSearchConfig.fromIndex,
    sortField: 'bagExt',
    sortDirection: 'desc',
  },
};
